import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from '../angular-material.module';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ICONS, ICON_PATH } from './icon.constants';

@NgModule({
  declarations: [],
  imports: [CommonModule, AngularMaterialModule]
})
export class IconModule {
  constructor(private domSanitizer: DomSanitizer, private matIconRegistry: MatIconRegistry) {
    this.addIconsToRegistry(ICONS);
  }

  addIconsToRegistry = (listOfIcons: string[]) => {
    listOfIcons.forEach((icon) => {
      this.matIconRegistry.addSvgIcon(
        icon,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`${ICON_PATH}/${icon}.svg`)
      );
    });
  };
}
